import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider } from '@angular/core';

import { errorInterceptor } from 'app/_helper/error/error.interceptor';
import { AuthService } from 'app/_services/auth.service';

export const provideError = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideHttpClient(withInterceptors([errorInterceptor])),
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AuthService),
      multi: true,
    },
  ];
};
